import { createAsyncThunk } from '@reduxjs/toolkit';
import roomsApi from '../../../api/roomsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'rooms';

export const CreateRoom = createAsyncThunk<any, any>(`${REDUCER_NAME}/createRoom`, async (data, thunkAPI) => {
  const res = await roomsApi.create(data);

  if (res.status === 200) {
    return { ...res.data };
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetRooms = createAsyncThunk(`${REDUCER_NAME}/getRooms`, async (__, thunkAPI) => {
  const res = await roomsApi.get();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetInventoryRooms = createAsyncThunk(`${REDUCER_NAME}/getInventoryRooms`, async (__, thunkAPI) => {
  const res = await roomsApi.getInventoryRooms();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const UpdateRoom = createAsyncThunk<any, any>(`${REDUCER_NAME}/updateRoom`, async ({ data, id }, thunkAPI) => {
  const res = await roomsApi.update(data, id);

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
